import { createTableSlice } from '../helpers';

export const tableSlice = createTableSlice({
  name: 'dataCurationDashboard/pendingTable',
  url: '/api/sequenceIntervals/staged',
});
